import { loopBackApi } from '../Api/LoopBackApi';
import LoopBackEndpoint from './LoopBackEndpoint';

class UserEndpoint extends LoopBackEndpoint {
  constructor() {
    super('users', 'id');
  }

  create(data) {
    const base = this.pickMatching(data, this.getBaseFields());
    const promises: any[] = [];

    if (Object.keys(base).length > 0) {
      promises.push(this.post(data));
    }

    return Promise.all(promises);
  }

  post(data) {
    return loopBackApi().post(this.getEndPoint(), data);
  }

  patch(base, rowData) {
    const id = rowData[this.getIndexKey()];
    return loopBackApi().patch(this.getPatchEndPoint(id), base);
  }

  update(changedData: {}, rowData) {
    const base = this.pickMatching(changedData, this.getBaseFields());
    const promises: any[] = [];

    if (Object.keys(base).length > 0) {
      promises.push(this.patch(base, rowData));
    }

    return Promise.all(promises);
  }

  login(formData: {}): Promise<any> {
    const endpoint = this.getEndPoint() + '/login';
    const data = this.pickMatching(formData, this.getBaseFieldsLogin());

    return loopBackApi().post(endpoint, data);
  }

  changePassword(formData: {}): Promise<any> {
    const endpoint = this.getEndPoint() + '/change-password';
    const data: any = this.pickMatching(formData, ['oldPassword', 'newPassword']);
    return loopBackApi().post(endpoint, data);
  }

  resetPassword(formData: {}, token: string): Promise<any> {
    const endpoint = this.getEndPoint() + '/reset-password?access_token=' + token;
    const data: any = this.pickMatching(formData, ['newPassword']);
    return loopBackApi().post(endpoint, data);
  }

  getBaseFields() {
    return ['first_name', 'last_name', 'email'];
  }

  getBaseFieldsLogin() {
    return ['email', 'password'];
  }

  getRelationFields() {
    return [];
  }
}

export default UserEndpoint;
